
    <fieldmagic-dialog
      label="Generate with AI"
      icon="magic"
    >
      <ng-template fieldmagicDialogButtonsTmp>
        <fieldmagic-primary-button
          [isInProgress]="processing$ | async"
          label="Generate"
          icon="magic"
          (click)="onGenerate()"
        >
        </fieldmagic-primary-button>

        <fieldmagic-dialog-close-button
          [instance]="self"
          [disabled]="processing$ | async"
        >
        </fieldmagic-dialog-close-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <fieldmagic-textarea-input
          [standalone]="false"
          label="Tell me more about the possible faults to be generated (This is optional)."
          [(ngModel)]="specifics"
          placeholder="Like standards, etc.."
        >
        </fieldmagic-textarea-input>
      </ng-template>
    </fieldmagic-dialog>
  